export const setProductWidth = (itemsInRow: number, margin: number): string => {
    const widths = {
        1: `calc(100% - ${margin}px)`,
        2: `calc(50% - ${margin}px)`,
        3: `calc(33% - ${margin}px)`,
        4: `calc(25% - ${margin}px)`,
        5: `calc(20% - ${margin}px)`,
        6: `calc(16.6% - ${margin}px)`
    };
    return widths[itemsInRow];
};